import axios from "axios";
import { config } from "../config";
import { GetMyChatsResponse } from "./api-types";

type HttpResponse<T> = {
  code?: number;
  payload: T;
  message: string;
  isSuccessful: boolean;
};

const axiosPublic = axios.create({
  baseURL: `${config.REACT_APP_BACKEND_URL}/`,
  withCredentials: true,
});

const axiosAuthenticated = axios.create({
  baseURL: `${config.REACT_APP_BACKEND_URL}/`,
  withCredentials: true,
});

axiosAuthenticated.interceptors.request.use(function (config) {
  const token = localStorage.getItem("token");
  config.headers.Authorization = "Bearer " + token;

  return config;
});

class HTTP {
  // ================================================================
  //                                CHAT
  // ================================================================

  getMyChats = async () => {
    const {
      data: { payload },
    } =
      await axiosAuthenticated.get<HttpResponse<GetMyChatsResponse>>(`/chats`);
    console.log(payload);
    return payload;
  };
}

export const http = new HTTP();
